import { render, staticRenderFns } from "./notifications-recording-export-complete.vue?vue&type=template&id=a51396d6&"
import script from "./notifications-recording-export-complete.vue?vue&type=script&lang=js&"
export * from "./notifications-recording-export-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports